
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/combo-of-the-day",
      function () {
        return require("private-next-pages/combo-of-the-day.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/combo-of-the-day"])
      });
    }
  